// Calculate how long an article takes to read
const initReadingTime = (theArticle) => {

	var readingTime = function (article) {
		this.article = article
		this.articleBody = article.querySelector('.js-reading-time-article')
		this.timeLabel = article.querySelector('.js-reading-time-label')
		if (this.timeLabel) {
			this.wordspermin = 225
			// If we dont have everything we need, abort
			if (!this.article && !this.articleBody && !this.timeLabel) return
			// If we do, then calculate the reading time

			let text = this.articleBody.innerText,
				wordCount = text.trim().split(/\s+/).length,
				readTime = Math.ceil(wordCount / this.wordspermin)

			if (readTime) this.timeLabel.innerText = `${readTime}`
        }
	};

	new readingTime(theArticle)
}

export default initReadingTime
